import { render } from "./App.vue?vue&type=template&id=4e1f53c8&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4e1f53c8&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1f53c8"]])

export default __exports__